/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_WorksInputs */

const en_hero_works = /** @type {(inputs: Hero_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`works`)
};

const ar_hero_works = /** @type {(inputs: Hero_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أعمال`)
};

const bn_hero_works = /** @type {(inputs: Hero_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাজ`)
};

const de_hero_works = /** @type {(inputs: Hero_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekte`)
};

const es_hero_works = /** @type {(inputs: Hero_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`proyectos`)
};

const fr_hero_works = /** @type {(inputs: Hero_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`projets`)
};

const pt_hero_works = /** @type {(inputs: Hero_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`projetos`)
};

const zh_hero_works = /** @type {(inputs: Hero_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作品`)
};

const tr_hero_works = /** @type {(inputs: Hero_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`projeler`)
};

const ru_hero_works = /** @type {(inputs: Hero_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`проекты`)
};

const pl_hero_works = /** @type {(inputs: Hero_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`projekty`)
};

/**
* | output |
* | --- |
* | "works" |
*
* @param {Hero_WorksInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_works = /** @type {((inputs?: Hero_WorksInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_WorksInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_hero_works(inputs)
	if (locale === "bn") return bn_hero_works(inputs)
	if (locale === "de") return de_hero_works(inputs)
	if (locale === "es") return es_hero_works(inputs)
	if (locale === "fr") return fr_hero_works(inputs)
	if (locale === "pt") return pt_hero_works(inputs)
	if (locale === "zh") return zh_hero_works(inputs)
	if (locale === "tr") return tr_hero_works(inputs)
	if (locale === "ru") return ru_hero_works(inputs)
	if (locale === "pl") return pl_hero_works(inputs)
	return en_hero_works(inputs)
});